import { InjectionToken } from '@angular/core';

export const ZUPER_APP_CONFIG = new InjectionToken<any>('ZUPER_APP_CONFIG');
